import type { PinEligibilityOut } from '@/api/endpoints/engagement'
import { errorMessage, isApiError } from '@/lib/errors'

/** O que a seção "Comentário fixado" mostra conforme a verificação do canal. */
export interface PinEligibilityView {
  /** O interruptor do fixado fica desabilitado. */
  disabled: boolean
  /** Mostra o aviso "Este canal ainda não pode fixar comentários". */
  notice: boolean
  /** O aviso acrescenta que o Studio recusou o último fixado. */
  refused: boolean
  /** O hint do interruptor diz que o fixado está pausado até a verificação. */
  pausedHint: boolean
  /**
   * O aviso mostra o botão "Conferir agora". O `studio_refused` não é relido
   * na hora (apps/backend/docs/plan-studio-pin-eligibility-refresh.md).
   */
  canRefresh: boolean
}

/**
 * O YouTube só deixa fixar comentário em canal verificado
 * (apps/backend/docs/plan-studio-pin-eligibility.md). `savedPinEnabled` é o
 * valor salvo, não o do formulário: quem desliga e muda de ideia antes de
 * salvar ainda consegue religar, e quem já tem o fixado ligado consegue
 * desligar. Campo ausente (backend velho) não muda nada.
 */
export function pinEligibilityView(
  eligibility: PinEligibilityOut | null | undefined,
  savedPinEnabled: boolean,
): PinEligibilityView {
  if (eligibility?.status !== 'blocked') {
    return { disabled: false, notice: false, refused: false, pausedHint: false, canRefresh: false }
  }
  const refused = eligibility.raw === 'studio_refused'
  return {
    disabled: !savedPinEnabled,
    notice: true,
    refused,
    pausedHint: savedPinEnabled,
    canRefresh: !refused,
  }
}

/**
 * A linha abaixo do aviso depois de um "Conferir agora". `null` quando não há
 * o que dizer: com `allowed`, o refetch do GET já some com o aviso.
 */
export function refreshResultLine(result: PinEligibilityOut | null | undefined, error: unknown): string | null {
  if (error) {
    if (isApiError(error) && error.status === 429) return 'Aguarde um minuto para conferir de novo.'
    return errorMessage(error, 'Não foi possível conferir agora.')
  }
  if (result?.status === 'blocked') return 'Conferido agora: o YouTube ainda não liberou.'
  return null
}
